import Vue from 'vue'
import masker from './../bibliotecas/mask/masker'

Vue.filter('toCnpj', (value) => {
    return masker(value, '##.###.###/####-##')
})

Vue.filter('toCpf', (value) => {
    return masker(value, '###.###.###-##')
})

Vue.filter('toCpfCnpj', (value) => {
    return masker(value, ['###.###.###-##', '##.###.###/####-##'])
})

Vue.filter('toStatus', (value) => {
    return `<strong>${value}</strong>`
})

Vue.filter('toTelefone', (value) => {
    return masker(value, ['(##) #####-####', '(##) ####-####'])
})

Vue.filter('toCep', (value) => {
    return masker(value, '#####-###')
})



// WEBPACK FOOTER //
// ./src/bibliotecas/appFiltros.js